import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';

import { reducer, initialState } from '../../reducers/auth';

import { useActions } from '../../actions/auth';

/**
  * Create Context
*/
export const AuthContext = createContext(initialState);

const AuthProvider = ({ children }) => {
  const [stateUser, dispatchUser] = useReducer(reducer, initialState);
  const actionsUser = (middleware) => useActions(middleware);

  /**
   * We will identify if exist user token on local storage
   * and call api to provide the user by token.
   *
   * This will be update all components that are using the user info.
   */
  React.useEffect(() => {
    if (!stateUser.isAuthenticated) {
      actionsUser(dispatchUser).fetchUserByToken();
    }
  }, []);

  return (
    <AuthContext.Provider value={{ stateUser, dispatchUser, actionsUser }}>
      {children}
    </AuthContext.Provider>
  )
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
  isAuthenticated: PropTypes.bool,
  fetchUserByToken: PropTypes.func.isRequired,
};

AuthProvider.defaultProps = {
  isAuthenticated: false,
};

export default AuthProvider;
